import { render, staticRenderFns } from "./contactView.vue?vue&type=template&id=aeea0c9a&"
import script from "./contactView.vue?vue&type=script&lang=js&"
export * from "./contactView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports